import script from "./CategoriesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesPage.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriesPage.vue?vue&type=style&index=0&id=239ecfc2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239ecfc2"]])

export default __exports__